export default `
§ uiKit.console.button: Copy
§ uiKit.console.notification: Text was copied
§ uiKit.dataLoader.page: Page
§ uiKit.dataLoader.size: Displayed
§ uiKit.dataLoader.rows: lines.
§ uiKit.dataLoader.from: out of
§ uiKit.dataLoader.all: Show all
§ uiKit.hoursChart.work: standard working hours (weekdays, 07:00 to 20:00)
§ uiKit.hoursChart.weekend: weekend days or time before/after working hours
§ uiKit.hoursChart.days: total number of commits in all time on a specific day and hour
§ uiKit.page.remove: Remove
§ uiKit.races.go: Let's go
§ uiKit.nothingFound.common.title: No or insufficient data to display
§ uiKit.nothingFound.common.description: The system will process more data if commits are signed in the format [Git commit message convention|https://www.conventionalcommits.org/en/v1.0.0/]. Template:
§ uiKit.nothingFound.common.console: Task_number type(feature): description
§ uiKit.nothingFound.common.example: For example:
§ uiKit.nothingFound.staff.title: No data for this employee
§ uiKit.nothingFound.staff.description1
They made edits not every working day and received the "Assistant" status.
The work of employees with such status on this project can be neglected as their contribution is insignificant in the general context.

§ uiKit.nothingFound.staff.description2
Therefore, the system does not calculate a number of indicators for him.
If this is an error and this employee needs to be calculated as usual, go to the “Settings” section and change his type.

§ common.title: Git statistics
§ common.filters: Filters
§ common.notifications.save: The changes have been saved
§ common.notifications.setting: The settings have been saved
§ common.fileLoader.notification: Cant open file $1
`;
